import React, { useEffect, useMemo, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Auth, I18n } from 'aws-amplify'
import { useAlert } from 'react-alert'
import ReactTooltip from 'react-tooltip'

import { clearStorage, exceptionsError, goToUrl, getUser } from '../../utils'

import {
  IconAlertSvg,
  IconLogoutSvg,
  IconPerfilSvg,
  LogoSvg
} from '../../assets/icons/svgComponents'

import { Overlay } from '../../styles'
import * as S from './styles'

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false)
  const [verifiedEmailBtn, setVerifiedEmailBtn] = useState(false)
  const navigate = useLocation()
  const history = useHistory()
  const alert = useAlert()
  const me = getUser()

  useMemo(async () => {
    const response = await Auth.currentUserInfo()

    if (response?.attributes?.email_verified) {
      return setVerifiedEmailBtn(true)
    }
  }, [])

  const verifyUserAttribute = async () => {
    try {
      const response = await Auth.currentAuthenticatedUser()

      await Auth.verifyUserAttribute(response, 'email')
      alert.show(I18n.get('ResendSignUpSuccess'), {
        type: 'success',
        timeout: 4000
      })
      goToUrl(history, '/confirmar-email')
    } catch (error: any) {
      alert.show(exceptionsError(error.code, error.message), {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const clickOutside = (event: React.FormEvent) => {
    if (event.target === event.currentTarget) {
      setOpenMenu(false)
    }
  }

  useEffect(() => {
    setOpenMenu(false)
  }, [navigate])

  return (
    <S.Wrapper className="no-print">
      <Link className="logo" to="/">
        <LogoSvg />
      </Link>
      <S.Content>
        {!verifiedEmailBtn && (
          <button
            className="verified-email"
            onClick={verifyUserAttribute}
            data-tip="Verifique seu e-mail"
          >
            <IconAlertSvg />
          </button>
        )}
        <ReactTooltip
          type="warning"
          place="bottom"
          effect="solid"
          className="tooptip-warning-custom"
        />
        <button onClick={() => setOpenMenu(!openMenu)} className="name-user">
          Bem vindo(a), <b>{me?.usuario?.nome}</b>
        </button>
      </S.Content>
      {openMenu && (
        <Overlay onClick={clickOutside}>
          <S.DropdownMenu>
            <div className="dropdown-title">
              <p>Admin</p>
              <p>{me?.usuario?.email}</p>
            </div>
            <div className="dropdown-content">
              <Link className="dropdown-link" to="/meus-dados">
                <IconPerfilSvg />
                <h4>Meus dados</h4>
              </Link>
            </div>
            <div className="dropdown-content">
              <button className="dropdown-logout" onClick={clearStorage}>
                <IconLogoutSvg />
                <h5>Sair</h5>
              </button>
            </div>
          </S.DropdownMenu>
        </Overlay>
      )}
    </S.Wrapper>
  )
}

export default Header
